// Global cache to store image validation results
const imageCache = new Map<string, boolean>()

function isImageValid(src: string): Promise<boolean> {
  if (imageCache.has(src)) {
    return Promise.resolve(imageCache.get(src) as boolean)
  }

  return new Promise<boolean>((resolve) => {
    const img = new Image()
    img.onload = () => {
      imageCache.set(src, true)
      resolve(true)
    }
    img.onerror = () => {
      imageCache.set(src, false)
      resolve(false)
    }
    img.src = src
  })
}

export default isImageValid
